import React from 'react';
import { Box, Typography, Button, useTheme } from '@mui/material';
import { LazyLoadImage } from 'react-lazy-load-image-component';

const SlideImageTall = ({ backgroundImage }) => {
    const theme = useTheme();

    return (
        <Box
            component={LazyLoadImage}
            height={1}
            width={1}
            src={backgroundImage}
            alt="..."
            // effect="blur"
            borderRadius={10}
            maxWidth={400}

            sx={{
                maxHeight: '90vh',
                objectFit: 'cover',
                // boxShadow: '19px 20px 0px 0 rgb(140 152 164 / 13%)',
                // filter: theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
            }}
        />

    );
};

export default SlideImageTall;
